import { render, staticRenderFns } from "./ed-goods.vue?vue&type=template&id=0e9ba012&scoped=true&"
import script from "./ed-goods.vue?vue&type=script&lang=js&"
export * from "./ed-goods.vue?vue&type=script&lang=js&"
import style0 from "./ed-goods.vue?vue&type=style&index=0&id=0e9ba012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ba012",
  null
  
)

export default component.exports